export default __webpack_public_path__ + "static/ux-strategy-a8fae46b6fd7cca2b271c4ebc69bec89.png";